import { Form, Col, Button } from 'react-bootstrap'
import { useFormContext, useFieldArray } from 'react-hook-form'
import { useAppendOne } from './Hooks'
import CustomInput from './CustomInput'

function PuntosDeVenta({ name, identificador, index, disabled }) {
  const { errors } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    name: identificador
  })

  useAppendOne(true, fields, append, {
    numero: ''
  })

  return (
    <Form.Row>
      <Col md={6}>
        {fields?.length > 0 ? (
          fields.map((punto, idx) => (
            <Form.Row key={punto.id}>
              <CustomInput
                md={8}
                type="text"
                placeholder="Es necesario ingresar el punto de venta"
                name={`${identificador}.${idx}.numero`}
                defaultValue={punto.numero}
                label={`Punto de venta ${idx + 1}`}
                errorPath={
                  errors?.[name]?.[index]?.puntos_de_venta?.[idx]?.numero
                }
                validation={{
                  required: {
                    value: true,
                    message: 'Es necesario ingresar el punto de venta.'
                  },
                  min: {
                    value: 1,
                    message: 'Debe ser mayor a cero.'
                  },
                  maxLength: {
                    value: 4,
                    message: 'Máximo 4 caracteres.'
                  },
                  minLength: {
                    value: 4,
                    message:
                      'Mínimo 4 caracteres. Completar con ceros a la izquierda.'
                  }
                }}
                disabled={disabled}
              />
              <Col md={4} className="pt-1">
                <Button
                  className="ml-auto mt-4"
                  variant="outline-secondary"
                  onClick={() => remove(idx)}
                  disabled={disabled}
                >
                  Borrar PTV {idx + 1}
                </Button>
              </Col>
            </Form.Row>
          ))
        ) : (
          <></>
        )}
        <Button
          variant="outline-primary"
          onClick={() => append()}
          disabled={disabled}
        >
          Agregar punto de venta
        </Button>
      </Col>
    </Form.Row>
  )
}

export default PuntosDeVenta
